export default __webpack_public_path__ + "static/Character-5500d97f820d810ae025dec2cd330d51.svg";